import(/* webpackMode: "eager", webpackExports: ["DashboardLayout"] */ "/opt/buildhome/repo/apps/personal-web/components/dashboard-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalContent"] */ "/opt/buildhome/repo/apps/personal-web/components/legal-content.tsx");
